import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export const FAQ = () => {
  const faqs = [{
    q: '¿Cuánto dura el alisado orgánico?',
    a: 'De 3 a 8 meses. Con buen mantenimiento, hasta 10 meses. Depende del tipo de cabello y el cuidado posterior.'
  }, {
    q: '¿Es seguro para cabello teñido?',
    a: 'Sí. Nuestra nanoplastia orgánica es apta para cabellos teñidos, decolorados y procesados.'
  }, {
    q: '¿Puedo hacerlo si estoy embarazada?',
    a: 'Sí. Nuestros tratamientos son libres de formol y seguros para embarazadas, lactantes y niñas.'
  }, {
    q: '¿Cuándo puedo lavar mi cabello después del tratamiento?',
    a: 'Recomendamos esperar de 48 a 72 horas para que el tratamiento selle completamente.'
  }, {
    q: '¿Necesito cita previa?',
    a: 'Sí. Atendemos con cita previa para darte la atención completa y personalizada que mereces.'
  }, {
    q: '¿Puedo asistir a la academia si no tengo experiencia?',
    a: 'Absolutamente. El programa está diseñado para principiantes y profesionales que quieren especializarse.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-16 bg-beige-50" data-id="element-117">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-118">
        <h2 className="text-3xl md:text-4xl font-serif text-center text-neutral-900 mb-12" data-id="element-119">
          Preguntas{' '}
          <span className="metallic-gold-text italic" data-id="element-120">frecuentes</span>
        </h2>

        <div className="space-y-4" data-id="element-121">
          {faqs.map((faq, index) => <div key={index} className="bg-white border border-beige-200 rounded-2xl overflow-hidden transition-all duration-200 hover:border-gold-200 shadow-sm" data-id="element-122">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" aria-expanded={openIndex === index} data-id="element-123">
                <span className="font-medium text-neutral-900 pr-4" data-id="element-124">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 metallic-gold-icon transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-125" />
              </button>

              <AnimatePresence data-id="element-126">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-127">
                    <div className="px-6 pb-5 text-neutral-600 leading-relaxed border-t border-beige-50 pt-4" data-id="element-128">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
};